@if (
  {
    isUnassignedRegionExpanded: isUnassignedRegionExpanded$ | async,
    maxHeight: maxHeight$ | async,
    defaultUnassignedSectionHeight: defaultUnassignedSectionHeight$ | async,
  };
  as data
) {
  <cdk-virtual-scroll-viewport
    class="unassigned-items-row"
    #viewport
    wilsonUnassignedServicesAndJobsVirtualScrollStrategyDirective
    [appendOnly]="true"
    [defaultRowHeightPx]="defaultRowHeight"
    [userTimelinesInfo]="rows"
    [style.height.px]="data.isUnassignedRegionExpanded ? data.maxHeight : 0"
    [style.min-height.px]="data.defaultUnassignedSectionHeight"
  >
    <wilson-dates-demarcator-lines
      [leftMarginPx]="0"
      [panelWidth]="(frameLength$ | async) || 0"
      [interval]="timeframe$ | async"
      [holidayRegions]="null"
      [visibleDaysRange]="visibleDaysRange$ | async"
    ></wilson-dates-demarcator-lines>
    <div
      *cdkVirtualFor="
        let innerRow of rows;
        let innerRowIndex = index;
        trackBy: trackByIds;
        templateCacheSize: 10
      "
      class="innerRow"
      [style.min-height]="defaultRowHeight + 'px'"
    >
      <wilson-unassigned-services-and-jobs-row
        [row]="innerRow"
      ></wilson-unassigned-services-and-jobs-row>
    </div>
  </cdk-virtual-scroll-viewport>
}
